<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Distance to Plant (Straight Line) </h4>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".7"></dxi-col>
            <dxi-col [ratio]=".3"></dxi-col>

            <dxi-item>
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"> Country </div>
                    <div class="dx-field-value">
                        <dx-select-box #countryDropDown [dataSource]="CountryDataSource" [acceptCustomValue]="true"
                            displayExpr="countryName" valueExpr="countryId" [(value)]="selectedCountry"
                            [searchEnabled]="true">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Please choose country.">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-select-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"> Miles from zip</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="miles">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Please enter miles.">
                                </dxi-validation-rule>
                                <dxi-validation-rule type="pattern" [pattern]="integerOnlyPattern"
                                    message="Only numbers are allowed.">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="2"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"> Zip (5-digit US, 3-6 digit CA)</div>
                    <div class="dx-field-value">
                        <dx-text-box #zipTextBox [(value)]="zip">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Please enter zip.">
                                </dxi-validation-rule>
                                <dxi-validation-rule *ngIf="selectedCountry == 'US'" type="custom"
                                    [(validationCallback)]="validationCallbackUS" message="Please enter a valid Zip.">
                                </dxi-validation-rule>
                                <dxi-validation-rule *ngIf="selectedCountry == 'CA'" type="custom"
                                    [(validationCallback)]="validationCallbackCA" message="Please enter a valid Zip.">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item class="leftmargin">
                <dxi-location [row]="0" [col]="3"></dxi-location>
                <div class="dx-field">
                    <dx-button class="ap-blue-btn" type="default" [useSubmitBehavior]="true" (onClick)="getReports()"
                        text="View Reports">
                    </dx-button>
                </div>
            </dxi-item>
        </dx-responsive-box>
        <hr />
    </div>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div class="topmargin" *ngIf="showReport">
        <h5 class="content-block">Plants Near Zip for {{zipDetails.city}}, {{zipDetails.region1}} {{zipDetails.zipCodeRoot}}
        </h5>
        <dx-data-grid id="gridContainer" class="fixGridHght" [dataSource]="dataSource" [allowColumnReordering]="true"
            [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [columnAutoWidth]="true"
            [rowAlternationEnabled]="true" [columnHidingEnabled]="false" [allowColumnResizing]="false">
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-filter-panel [visible]="false"></dxo-filter-panel>
            <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
            <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
                [showInfo]="true" [showNavigationButtons]="true">
            </dxo-pager>
            <dxo-toolbar>
                <dxi-item name="groupPanel"></dxi-item>
                <dxi-item location="after">
                    <dx-button class="ap-blue-btn" text="Reset" (onClick)="resetFilters()">
                    </dx-button>
                    <dx-button icon="exportxlsx" class="ap-blue-btn" (onClick)="exportExcel($event)"
                        text="Export to Excel">
                    </dx-button>
                </dxi-item>
                <dxi-item name="searchPanel"></dxi-item>
            </dxo-toolbar>
            <dxi-column dataField="plantType" caption="Plant Type"></dxi-column>
            <dxi-column dataField="miles" caption="Miles"></dxi-column>
            <dxi-column dataField="company" caption="Company"></dxi-column>
            <dxi-column dataField="siteName" caption="Site Name"></dxi-column>
            <dxi-column dataField="city" caption="City"></dxi-column>
            <dxi-column dataField="stateProv" caption="State/Province"></dxi-column>
            <dxi-column dataField="zipCode" caption="Zip Code"></dxi-column>
        </dx-data-grid>
    </div>
</div>
